import React from "react";
import { withTranslation } from "react-multi-lang";
import { withAlert } from "react-alert";
import KendoNestedGrid from "./../../controls/KendoNestedGrid"
// import {
//     Silentauditobject
// } from "./../../custom_functions/Functions.jsx";
// import { AuditModuleNameEnum } from "./../../custom_functions/AuditActionEnum";

const DashboardProjectView = (props) => {
    let ELNurl = window.appUrl.ELN;

    const [projectgriddetails, setProjectgriddetails] = React.useState({
        praentgridname: "dash_projectview_parent",
        childgridname: "dash_projectview_child",
        parentcolumns: [
            {
                header: props.t("Masters.Projectmaster.IDS_LBL_PROJECTNAME", {
                    param: "",
                }),
                datatype: "projectname",
                rowselector: false,
                visible: true,
                defaultvisible: true,
                filterable: false,
                className: "clsModulename",
                width: "140px",
            },

            {
                header: props.t("Masters.Projectmaster.IDS_LBL_PROJECTTEAM", {
                    param: "",
                }),
                datatype: "teamname",
                rowselector: false,
                visible: true,
                filterable: true,
                className: "clsModulename",
                width: "160px",
            },
            {
                header: props.t("Masters.Projectmaster.IDS_LBL_CREATEDBY", {
                    param: "",
                }),
                datatype: "createdby",
                rowselector: false,
                visible: true,
                filterable: true,
                className: "clsModulename",
                width: "200px",
            },
            {
                header: props.t(
                    "Masters.Projectmaster.IDS_LBL_CREATEDON",
                    {
                        param: "",
                    }
                ),
                datatype: "createdonview",
                rowselector: false,
                visible: true,
                filterable: true,
                className: "clsModulename",
                width: "200px",
                orginatefrom: "createdon",
                valuetype: "date"
            },
            {
                header: props.t("Masters.Projectmaster.IDS_LBL_PROJECTSTATUS", {
                    param: "",
                }),
                datatype: "projectstatus",
                rowselector: false,
                visible: true,
                filterable: true,
                className: "clsModulename",
                width: "200px",
            }
        ],
        parentfetchurl: ELNurl + "/DashBoard/Getprojectsonuser",
        parentpassobject: { usercode: sessionStorage.getItem("User"), lssitemaster: { sitecode: sessionStorage.getItem("Usersite") } },
        parenttoolbar: [{
            ctrltype: "radio", value: "1",
            dofetchonchange: true,
            fetchurl: ELNurl + "/DashBoard/Getprojectsonuser",
            name: "projecttype",
            text: "All projects",
            isshowcount: true,
            countfetchurl: ELNurl + "/DashBoard/Getprojectscountonuser",
            countpassobject: { usercode: sessionStorage.getItem("User"), lssitemaster: { sitecode: sessionStorage.getItem("Usersite") } },
            image: "images/total-orders.svg"
        },
        {
            ctrltype: "radio", value: "2",
            dofetchonchange: true,
            fetchurl: ELNurl + "/DashBoard/Getprojectsoverdueonuser",
            name: "projecttype",
            text: "All projects with due date",
            isshowcount: true,
            countfetchurl: ELNurl + "/DashBoard/Getprojectsoverduecountonuser",
            countpassobject: { usercode: sessionStorage.getItem("User"), lssitemaster: { sitecode: sessionStorage.getItem("Usersite") } },
            image: "images/total-orders.svg"
        },
        {
            ctrltype: "radio", value: "3",
            dofetchonchange: true,
            fetchurl: ELNurl + "/DashBoard/GetInitprojectsonuser",
            name: "projecttype",
            text: "Initiated projects",
            isshowcount: true,
            countfetchurl: ELNurl + "/DashBoard/Getintprojectscountonuser",
            countpassobject: { usercode: sessionStorage.getItem("User"), lssitemaster: { sitecode: sessionStorage.getItem("Usersite") } },
            image: "images/pending.svg"
        },
        {
            ctrltype: "radio", value: "4",
            dofetchonchange: true,
            fetchurl: ELNurl + "/DashBoard/Getinprogressprojectsonuser",
            name: "projecttype",
            text: "In-progress projects",
            isshowcount: true,
            countfetchurl: ELNurl + "/DashBoard/Getinprojectscountonuser",
            countpassobject: { usercode: sessionStorage.getItem("User"), lssitemaster: { sitecode: sessionStorage.getItem("Usersite") } },
            image: "images/pending.svg"
        },
        {
            ctrltype: "radio", value: "5",
            dofetchonchange: true,
            fetchurl: ELNurl + "/DashBoard/Getcomprojectsonuser",
            name: "projecttype",
            text: "Completed projects",
            isshowcount: true,
            countfetchurl: ELNurl + "/DashBoard/Getcomprojectscountonuser",
            countpassobject: { usercode: sessionStorage.getItem("User"), lssitemaster: { sitecode: sessionStorage.getItem("Usersite") } },
            image: "images/completed.svg"
        },
        {
            ctrltype: "radio", value: "6",
            dofetchonchange: true,
            fetchurl: ELNurl + "/DashBoard/GetOverdueprojectsonuser",
            name: "projecttype",
            text: "Overdue projects",
            isshowcount: true,
            countfetchurl: ELNurl + "/DashBoard/Getoverdueprojectscountonuser",
            countpassobject: { usercode: sessionStorage.getItem("User"), lssitemaster: { sitecode: sessionStorage.getItem("Usersite") } },
            image: "images/rejected-order.svg"
        }, {
            ctrltype: "columnfilter", value: "",
            dofetchonchange: false,
            name: "columnfilter",
            text: "",
        }],
        parentprimarykey: "projectcode",
        childcolumns: [
            {
                header: "Order ID",
                datatype: "bi",
                rowselector: false,
                visible: true,
                defaultvisible: true,
                doFilter: true,
                resizable: false,
                sortable: false,
                pathName: "/registertask",
                currentpath: "/dashboard",
                celltype: "link",
                className: "simple-grid-view",
                width: "100px",
                Isshow: true,
                Desabled: true,
                linkpassdata: { batchid: "bi", batchcode: "bc" },
                noshowlink: { retirestatus: 1, transactionstatus: this.props.t("Templates.Protocol.IDS_LBL_RETIRED"), ordercancell: 1 },
                orginatefrom: "batchid",
                valuetype: "formatsequence"
            },
            {
                header: props.t("Templates.Sheettemplates.IDS_LBL_SHEETNAME", {
                    param: "",
                }),
                datatype: "fn",
                rowselector: false,
                visible: true,
                filterable: false,
                className: "clsModulename",
                width: "140px",
            },
            {
                header: props.t("Dashboard.IDS_LBL_TASK"),
                datatype: "tn",
                rowselector: false,
                visible: true,
                doFilter: true,
                resizable: false,
                celltype: "noWrapColumn",
                className: "simple-grid-view",
                maxWidth: 100,
                headerTemplate: "<span title='Task'>Task</span>",
                Isshow: true

            },
            {
                header: props.t("Dashboard.IDS_LBL_CREATEDDATE"),
                celltype: "dateColumn",
                datatype: "createdtimestamp",
                rowselector: false,
                sortable: false,
                visible: true,
                doFilter: true,
                resizable: false,
                className: "simple-grid-view",
                width: "200px",
                Isshow: true,
                orginatefrom: "ct",
                valuetype: "date"
            },
            {
                header: props.t("Orders.Sheetorders.IDS_LBL_DATECOMPLETED"),
                celltype: "Datecolumn_Completed",
                datatype: "completedtimestamp",
                rowselector: false,
                sortable: false,
                visible: true,
                doFilter: true,
                resizable: false,
                className: "simple-grid-view",
                width: "200px",
                orginatefrom: "cot",
                valuetype: "date"
            },
            {
                header: props.t("Dashboard.IDS_LBL_PROJECT"),
                datatype: "pn",
                rowselector: false,
                visible: true,
                doFilter: true,
                celltype: "noWrapColumn",
                resizable: false,
                className: "simple-grid-view",
                maxWidth: 100,
                Isshow: true
            },
            {
                header: props.t("Orders.Sheetorders.IDS_LBL_MATNAME"),
                datatype: "materialname",
                rowselector: false,
                visible: true,
                doFilter: true,
                celltype: "noWrapColumn",
                resizable: false,
                className: "simple-grid-view",
                maxWidth: 100,
                // Isshow: true
            },
            {
                header: props.t("Orders.Sheetorders.IDS_LBL_KEYWORD"),
                datatype: "kw",
                rowselector: false,
                visible: true,
                doFilter: true,
                resizable: false,
                className: "simple-grid-view",
                maxWidth: 100
            },
            {
                header: props.t("Dashboard.IDS_LBL_STATUS"),
                datatype: "status",
                rowselector: false,
                visible: true,
                doFilter: true,
                celltype: "status",
                resizable: false,
                className: "simple-grid-view",
                maxWidth: 100,
                Isshow: true,
                statusvalidation: {
                    "OverDue": { "on.isduedateexhausted": true, "on.iscompleted": false },
                    "In-Progress": { as: 1, of: "N", oc: undefined },
                    "Approved": { of: "R", as: 1, oc: undefined },
                    "Rejected": { as: 3, oc: undefined },
                    "Cancelled": { oc: 1 },
                    "Created": { of: "N" }
                }

            },
            {
                header: props.t("Dashboard.IDS_LBL_DUEDATE"),
                datatype: "duedate",
                rowselector: false,
                visible: true,
                doFilter: true,
                resizable: false,
                celltype: "dateColumn_duedate",
                className: "simple-grid-view",
                maxWidth: 90,
                // Isshow: true
            },
            {
                header: props.t("Dashboard.IDS_LBL_WORKFLOWLEVEL"),
                datatype: "lsw.workflowname",
                rowselector: false,
                visible: true,
                doFilter: true,
                celltype: "noWrapColumn",
                resizable: false,
                className: "simple-grid-view",
                width: "100px",
                headerTemplate: "<span title='Workflow Level'>Workflow Level</span>",
                Isshow: true
            }
        ],
        childfetchurl: ELNurl + "/DashBoard/Getorderonproject",
        childtoolbar: [{
            ctrltype: "radio", value: "1",
            dofetchonchange: true,
            fetchurl: ELNurl + "/DashBoard/Getorderonproject",
            name: "ordertype",
            text: "Sheet",
            columnsonfetch: [
                {
                    header: "Order ID",
                    datatype: "batch",
                    rowselector: false,
                    visible: true,
                    doFilter: true,
                    defaultvisible: true,
                    resizable: false,
                    sortable: false,
                    pathName: "/registertask",
                    currentpath: "/dashboard",
                    celltype: "link",
                    className: "simple-grid-view",
                    width: "100px",
                    Isshow: true,
                    Desabled: true,
                    linkpassdata: { batchid: "bi", batchcode: "bc" },
                    noshowlink: { retirestatus: 1, transactionstatus: this.props.t("Templates.Protocol.IDS_LBL_RETIRED"), ordercancell: 1 },
                    orginatefrom: "batchid",
                    valuetype: "formatsequence"
                },
                {
                    header: props.t("Templates.Sheettemplates.IDS_LBL_SHEETNAME", {
                        param: "",
                    }),
                    datatype: "fn",
                    rowselector: false,
                    visible: true,
                    filterable: false,
                    className: "clsModulename",
                    width: "140px",
                },
                {
                    header: props.t("Dashboard.IDS_LBL_TASK"),
                    datatype: "tn",
                    rowselector: false,
                    visible: true,
                    doFilter: true,
                    resizable: false,
                    celltype: "noWrapColumn",
                    className: "simple-grid-view",
                    maxWidth: 100,
                    headerTemplate: "<span title='Task'>Task</span>",
                    Isshow: true

                },
                {
                    header: props.t("Dashboard.IDS_LBL_CREATEDDATE"),
                    celltype: "dateColumn",
                    datatype: "createdtimestamp",
                    rowselector: false,
                    sortable: false,
                    visible: true,
                    doFilter: true,
                    resizable: false,
                    className: "simple-grid-view",
                    width: "200px",
                    Isshow: true,
                    orginatefrom: "ct",
                    valuetype: "date"
                },
                {
                    header: props.t("Orders.Sheetorders.IDS_LBL_DATECOMPLETED"),
                    celltype: "Datecolumn_Completed",
                    datatype: "completedtimestamp",
                    rowselector: false,
                    sortable: false,
                    visible: true,
                    doFilter: true,
                    resizable: false,
                    className: "simple-grid-view",
                    width: "200px",
                    orginatefrom: "cot",
                    valuetype: "date"
                }, {
                    header: props.t("Dashboard.IDS_LBL_PROJECT"),
                    datatype: "pn",
                    rowselector: false,
                    visible: true,
                    doFilter: true,
                    celltype: "noWrapColumn",
                    resizable: false,
                    className: "simple-grid-view",
                    maxWidth: 100,
                    Isshow: true
                },
                {
                    header: props.t("Orders.Sheetorders.IDS_LBL_MATNAME"),
                    datatype: "materialname",
                    rowselector: false,
                    visible: true,
                    doFilter: true,
                    celltype: "noWrapColumn",
                    resizable: false,
                    className: "simple-grid-view",
                    maxWidth: 100,
                    // Isshow: true
                },
                {
                    header: props.t("Orders.Sheetorders.IDS_LBL_KEYWORD"),
                    datatype: "kw",
                    rowselector: false,
                    visible: true,
                    doFilter: true,
                    resizable: false,
                    className: "simple-grid-view",
                    maxWidth: 100
                },
                {
                    header: props.t("Dashboard.IDS_LBL_STATUS"),
                    datatype: "status",
                    rowselector: false,
                    visible: true,
                    doFilter: true,
                    celltype: "status",
                    resizable: false,
                    className: "simple-grid-view",
                    maxWidth: 100,
                    Isshow: true,
                    statusvalidation: {
                        "OverDue": { "on.isduedateexhausted": true, "on.iscompleted": false },
                        "In-Progress": { as: 1, of: "N", oc: undefined },
                        "Approved": { of: "R", as: 1, oc: undefined },
                        "Rejected": { as: 3, oc: undefined },
                        "Cancelled": { oc: 1 },
                        "Created": { of: "N" }
                    }
                },
                {
                    header: props.t("Dashboard.IDS_LBL_DUEDATE"),
                    datatype: "duedate",
                    rowselector: false,
                    visible: true,
                    doFilter: true,
                    resizable: false,
                    celltype: "dateColumn_duedate",
                    className: "simple-grid-view",
                    maxWidth: 90
                },
                {
                    header: props.t("Dashboard.IDS_LBL_WORKFLOWLEVEL"),
                    datatype: "lsw.workflowname",
                    rowselector: false,
                    visible: true,
                    doFilter: true,
                    celltype: "noWrapColumn",
                    resizable: false,
                    className: "simple-grid-view",
                    width: "100px",
                    headerTemplate: "<span title='Workflow Level'>Workflow Level</span>",
                    Isshow: true
                }
            ]
        },
        {
            ctrltype: "radio", value: "2",
            dofetchonchange: true,
            fetchurl: ELNurl + "/DashBoard/Getprotocolorderonproject",
            name: "ordertype",
            text: "Protocol",
            columnsonfetch: [
                {
                    header: "Order ID",
                    datatype: "batch",
                    rowselector: false,
                    visible: true,
                    doFilter: true,
                    defaultvisible: true,
                    resizable: false,
                    sortable: false,
                    currentpath: "/dashboard",
                    celltype: "link",
                    pathName: "/Protocolorder",
                    className: "simple-grid-view",
                    width: "100px",
                    Isshow: true,
                    Desabled: true,
                    linkpassdata: {
                        batchid: "pn", protocolordercode: "pc",
                        lsprotocolmaster: "lpm", createdtimestamp: "ct"
                    },
                    noshowlink: { retirestatus: 1, transactionstatus: this.props.t("Templates.Protocol.IDS_LBL_RETIRED"), ordercancell: 1 },
                    orginatefrom: "protoclordername",
                    valuetype: "formatsequence"
                },
                {
                    header: props.t("Orders.Protocolorders.IDS_LBL_PROTOCOL", {
                        param: "",
                    }),
                    datatype: "pmn",
                    rowselector: false,
                    visible: true,
                    filterable: false,
                    className: "clsModulename",
                    width: "140px",
                },
                {
                    header: props.t("Dashboard.IDS_LBL_TASK"),
                    datatype: "tn",
                    rowselector: false,
                    visible: true,
                    doFilter: true,
                    resizable: false,
                    celltype: "noWrapColumn",
                    className: "simple-grid-view",
                    maxWidth: 100,
                    Isshow: true
                },
                {
                    header: props.t("Dashboard.IDS_LBL_CREATEDDATE"),
                    celltype: "dateColumn",
                    datatype: "createdtimestamp",
                    rowselector: false,
                    sortable: false,
                    // celltype: "noWrapColumn",
                    visible: true,
                    doFilter: true,
                    resizable: false,
                    className: "simple-grid-view",
                    width: "100px",
                    Isshow: true,
                    orginatefrom: "ct",
                    valuetype: "date"
                },
                {
                    header: props.t("Orders.Sheetorders.IDS_LBL_DATECOMPLETED"),
                    celltype: "Datecolumn_Completed",
                    datatype: "completedtimestamp",
                    rowselector: false,
                    sortable: false,
                    visible: true,
                    doFilter: true,
                    resizable: false,
                    className: "simple-grid-view",
                    width: "200px",
                    orginatefrom: "cot",
                    valuetype: "date"
                },
                {
                    header: props.t("Dashboard.IDS_LBL_PROJECT"),
                    datatype: "pjn",
                    rowselector: false,
                    celltype: "noWrapColumn",
                    visible: true,
                    doFilter: true,
                    resizable: false,
                    className: "simple-grid-view",
                    maxWidth: 100,
                    Isshow: true
                },
                {
                    header: props.t("Orders.Sheetorders.IDS_LBL_MATNAME"),
                    datatype: "mn",
                    rowselector: false,
                    visible: true,
                    doFilter: true,
                    celltype: "noWrapColumn",
                    resizable: false,
                    className: "simple-grid-view",
                    maxWidth: 100,
                    // Isshow: true
                },
                {
                    header: props.t("Orders.Sheetorders.IDS_LBL_KEYWORD"),
                    datatype: "kw",
                    rowselector: false,
                    visible: true,
                    doFilter: true,
                    resizable: false,
                    className: "simple-grid-view",
                    maxWidth: 100
                },
                {
                    header: props.t("Dashboard.IDS_LBL_STATUS"),
                    datatype: "status",
                    rowselector: false,
                    visible: true,
                    doFilter: true,
                    celltype: "status",
                    resizable: false,
                    className: "simple-grid-view",
                    maxWidth: 100,
                    Isshow: true,
                    statusvalidation: {
                        "OverDue": { "on.isduedateexhausted": true, "on.iscompleted": false },
                        "In-Progress": { as: 1, of: "N", oc: undefined },
                        "Approved": { of: "R", as: 1, oc: undefined },
                        "Rejected": { as: 3, oc: undefined },
                        "Cancelled": { oc: 1 },
                        "Created": { of: "N" }
                    }
                },
                {
                    header: props.t("DueDate"),
                    datatype: "duedate",
                    rowselector: false,
                    visible: true,
                    doFilter: true,
                    resizable: false,
                    celltype: "dateColumn_duedate",
                    className: "simple-grid-view",
                    maxWidth: 90,
                    // Isshow: true
                },
                {
                    header: props.t("Dashboard.IDS_LBL_WORKFLOWLEVEL"),
                    datatype: "lepw.workflowname",
                    rowselector: false,
                    visible: true,
                    doFilter: true,
                    resizable: false,
                    className: "simple-grid-view",
                    celltype: "noWrapColumn",
                    width: "100px",
                    Isshow: true

                }
            ]
        }, {
            ctrltype: "columnfilter", value: "",
            dofetchonchange: false,
            name: "columnfilter",
            text: "",
        }]

    });
    return (<div className="container-fluid kendo-dashboardview">
        <KendoNestedGrid griddetails={projectgriddetails} />
    </div>);
}
export default withAlert()(withTranslation(DashboardProjectView));